module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 p-2 min-h-screen"
  }, [_c('h3', {
    staticClass: "font-bold mb-3 text-gray-700 text-center"
  }, [(!_vm._id) ? _c('span', [_vm._v("Nuevo ")]) : _vm._e(), (_vm.copiando) ? _c('span', [_vm._v("Copiando ")]) : _vm._e(), _c('span', [_vm._v("Gasto")]), (_vm._id) ? _c('div', [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Creado " + _vm._s(_vm._f("fromNow")(_vm.fechaCreacion)))])]) : _vm._e(), (_vm.copiando) ? _c('div', [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Copiando cirugía, haga los cambios necesarios y presione guardar")])]) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "fecha",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fecha),
      expression: "fecha"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fecha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fecha = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "tipo-gasto",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo gasto")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionTipoGasto),
      expression: "descripcionTipoGasto"
    }],
    ref: "tipoGasto",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionTipoGasto)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }],
      "click": function($event) {
        _vm.showPopoverTipoGasto = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionTipoGasto = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-funnel-dollar text-gray-500"
  })]), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTipoGasto = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTipoGasto) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTipoGasto = false
      }
    }
  }, [_c('tipo-gasto-seleccionar', {
    on: {
      "selected": _vm.seleccionarTipoGasto,
      "close": _vm.cerrarTipoGasto
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "empleado",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Empleado")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreEmpleado),
      expression: "nombreEmpleado"
    }],
    ref: "empleado",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'tecnico' || _vm.perfil === 'enfermera'
    },
    domProps: {
      "value": (_vm.nombreEmpleado)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverEmpleado = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverEmpleado = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverEmpleado = true
      }],
      "click": function($event) {
        _vm.showPopoverEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user text-gray-500"
  })]), (_vm.perfil !== 'tecnico' && _vm.perfil !== 'enfermera') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverEmpleado) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverEmpleado = false
      }
    }
  }, [_c('empleado-seleccionar', {
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": _vm.cerrarEmpleado
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "moneda",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Moneda")]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.moneda === 'soles'
    },
    on: {
      "click": function($event) {
        _vm.moneda = 'soles'
      }
    }
  }, [_c('div', {
    staticClass: "text-gray-500"
  }, [_vm._v("S/")]), _c('span', [_vm._v("Soles")])]), _c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.moneda === 'dolares'
    },
    on: {
      "click": function($event) {
        _vm.moneda = 'dolares'
      }
    }
  }, [_c('div', {
    staticClass: "text-gray-500"
  }, [_vm._v("$")]), _c('span', [_vm._v("Dólares")])])])])]), _c('div', {
    key: "monto",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Monto")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.monto),
      expression: "monto"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.monto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.monto = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "comentario",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Comentario")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comentario),
      expression: "comentario"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    domProps: {
      "value": (_vm.comentario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comentario = $event.target.value
      }
    }
  })])]), (_vm.copiando) ? _c('div', {
    key: "copy-message",
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Copiando cirugía, haga los cambios necesarios y presione guardar")])]) : _vm._e(), _c('div', {
    key: "acciones",
    staticClass: "flex mb-2 justify-center mb-20"
  }, [_c('div', {
    staticClass: "bg-primary text-sm flex items-center text-white py-2 px-4 rounded cursor-pointer",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Guardar")]), (_vm._id) ? _c('div', {
    staticClass: "text-primary text-sm flex items-center border-primary border py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.irANuevoGasto
    }
  }, [_vm._v("Nuevo gasto")]) : _vm._e(), (_vm._id && _vm.copiando === false) ? _c('div', {
    staticClass: "bg-primary text-sm flex items-center text-white py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Duplicar")]) : _vm._e(), (_vm.perfil === 'administrador' && _vm._id && !_vm.copiando) ? _c('div', {
    staticClass: "bg-red-500 text-sm flex items-center text-white py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Eliminar")]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-799bffac","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/v_gasto_form.vue
// module id = 235
// module chunks = 1